<template>
  <div class="create-note notes-preview">
    <template v-if="!isLoading">
      <label class="add-note">
        <span class="add-note-label">Notes</span>
        <textarea rows="10" v-model="note" placeholder="Write your notes here"></textarea>
      </label>
      <div v-if="error" class="error-msg">
        {{error}}
      </div>
      <div class="notes-actions">
        <vi-button :disabled="!this.note" label="Save" size="sm" @click="saveNote"/>
        <vi-button :disabled="!this.note" label="Delete" size="sm" @click="deleteNote"/>
      </div>
    </template>
    <loading-logo v-if="isLoading" :autoplay="true"/>
  </div>
</template>

<script>
  import ViButton from "../ui/ViButton";
  import LoadingLogo from "../LoadingLogo";
  import {mapState} from 'vuex';

  export default {
    name: 'NotesPreview',
    components: {LoadingLogo, ViButton},
    props: {
      sessionLog: {
        type: Object
      }
    },

    computed: {
      ...mapState({
        sessionLogsMap: state => state.sessions.map
      }),
      sessionLogComputed() {
        return this.sessionLog && this.sessionLogsMap[this.sessionLog.id]
      },
      activeNote() {
        return this.sessionLogComputed && this.sessionLogComputed.notes[0]
      }
    },

    data: () => ({
      note: null,
      error: null,
      isLoading: false
    }),

    methods: {
      deleteNote() {
        this.note = '';
        this.saveNote();
      },
      saveNote() {
        this.isLoading = true;

        if (this.activeNote) {
          this.$store.dispatch('notes/updateNoteInSessionLog', {
            callSid: this.sessionLogComputed.callSid,
            note: this.note,
            id: this.sessionLogComputed.id
          })
            .then(() => {
              this.isLoading = false
            })
            .catch((err) => {
              this.isLoading = false;
              this.error = 'An error has occurred. Please try again or contact support'
            })
        } else {
          this.$store.dispatch('notes/saveNoteInSessionLog', {
            callSid: this.sessionLogComputed.callSid,
            note: this.note,
            id: this.sessionLogComputed.id
          })
            .then(() => {
              this.isLoading = false
            })
            .catch((err) => {
              this.isLoading = false;
              this.error = 'An error has occurred. Please try again or contact support'
            })
        }
      },
    },

    created() {
      this.note = this.activeNote ? this.activeNote.note : null
    }
  }
</script>

<style lang="scss">
  @import "NotesPreview";
</style>
